import { app } from '../../../../app';

app.component('companySmsServicesConfirmTurnOff', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    templateUrl: require('./confirm-turn-off-sms-service.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/confirm-turn-off/confirm-turn-off-sms-service.component.js